

<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <form role="form" @submit.stop.prevent="teste">
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="success"
            type="gradient"
            class="d-inline"
            @click="onSubmit"
            >Salvar Alterações</vs-button
          >
        </div>
      </div>
      <table class="simpleTablePrincipal" width="100%">
        <tr>
          <th>Tipo</th>
          <th width="60%">Nome</th>
          <th width="30%">SGA</th>
        </tr>
        <tr v-for="item in itens" :key="item.id">
          <td>{{ item.tipo }}</td>
          <td>{{ item.nomeLista }}</td>
          <td>
            <div v-if="item.idSGA">
              <vs-button
                radius
                color="success"
                type="gradient"
                icon-pack="feather"
                icon="icon-edit"
                class="d-inline"
                @click="item.idSGA = null"
                >{{ item.idSGA }}</vs-button
              >
              <vs-button
                v-if="item.tipo == 'Tipo Veiculos'"
                nativeType="button"
                color="warning"
                type="gradient"
                icon-pack="feather"
                icon="icon-edit"
                class="d-inline"
                @click="buscaCategoria(item)"
                >Alterar Categoria {{ item.idSGAAUX }}</vs-button
              >

              <v-select
                v-if="item.alteraCategoria == true"
                :options="item.categoriasSga"
                :value="item.sga"
                taggable
                :create-option="(sga) => criaSubItem(item, sga)"
                @input="(sga) => updataSubItem(item, sga)"
              />
            </div>
            <div v-else>
              <vs-input
                type="number"
                size="large"
                class="w-full"
                v-model="item.sga"
                @blur="updataItem2(item)"
                v-if="item.tipo.indexOf('Cota -') >= 0"
              />
              <vs-input
                type="number"
                size="large"
                class="w-full"
                v-model="item.sga"
                @blur="updataItem2(item)"
                v-if="item.tipo == 'Usuários' && usuariosSga.length == 0"
              />
              <v-select
                v-else-if="item.tipo == 'Usuários'"
                :options="usuariosSga"
                :value="item.sga"
                taggable
                :create-option="(sga) => criaItem(item, sga)"
                @input="(sga) => updataItem(item, sga)"
              />
              <vs-input
                type="number"
                size="large"
                class="w-full"
                v-model="item.sga"
                @blur="updataItem2(item)"
                v-if="item.tipo == 'Produtos' && produtosSga.length == 0"
              />
              <v-select
                v-else-if="item.tipo == 'Produtos'"
                :options="produtosSga"
                :value="item.sga"
                taggable
                :create-option="(sga) => criaItem(item, sga)"
                @input="(sga) => updataItem(item, sga)"
              />
              <vs-input
                type="number"
                size="large"
                class="w-full"
                v-model="item.sga"
                @blur="updataItem2(item)"
                v-if="item.tipo == 'Tipo Veiculos' && tiposSga.length == 0"
              />
              <v-select
                v-else-if="item.tipo == 'Tipo Veiculos'"
                :options="tiposSga"
                :value="item.sga"
                taggable
                :create-option="(sga) => criaItem(item, sga)"
                @input="(sga) => updataItem(item, sga)"
              />
              <vs-input
                type="number"
                size="large"
                class="w-full"
                v-model="item.sga"
                @blur="updataItem2(item)"
                v-if="item.tipo == 'Regionais' && cooperativasSga.length == 0"
              />
              <v-select
                v-else-if="item.tipo == 'Regionais'"
                :options="cooperativasSga"
                :value="item.sga"
                taggable
                :create-option="(sga) => criaItem(item, sga)"
                @input="(sga) => updataItem(item, sga)"
              />

              <vs-input
                type="number"
                size="large"
                class="w-full"
                v-model="item.sga"
                @blur="updataItem2(item)"
                v-if="item.tipo == 'Divisões' && regionaisSga.length == 0"
              />
              <v-select
                v-else-if="item.tipo == 'Divisões'"
                :options="regionaisSga"
                :value="item.sga"
                taggable
                :create-option="(sga) => criaItem(item, sga)"
                @input="(sga) => updataItem(item, sga)"
              />

            </div>
          </td>
        </tr>
      </table>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="success"
            type="gradient"
            class="d-inline"
            @click="onSubmit"
            >Salvar Alterações</vs-button
          >
        </div>
      </div>
      <!------------ START INFORMAÇÕES DO Perfil ------------>
      <ModalInfo
        :modalSelecionado="modalSelecionado"
        :popupActive="popupActive"
        :title="`Dados da Integração`"
        @close="popupActive = false"
      ></ModalInfo>
    </form>

    <!------------ END INFORMAÇÕES DO Perfil ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>


<!------------ START SCRIPT ------------>
<script>
import AddNewDataSidebar from "./../Includes/SideBar";
import service from "../../services";
import downloadexcel from "vue-json-excel";
import ModalInfo from "../../components/ModalInfo";
import vSelect from "vue-select";
import BotaoSubmit from "../../components/BotaoSubmit";
export default {
  components: {
    AddNewDataSidebar,
    downloadexcel,
    ModalInfo,
    vSelect,
    BotaoSubmit,
  },
  data() {
    return {
      idEmpresa: null,
      aguardeCadastro: false,
      dadosSideBar: {},
      controllerGeral: "IntegracaoSGA",
      formSideBar: "IntegracaoSGA",
      entidade: "Integração",
      titleSideBar: "Adicionar Integração",
      popupActive: false,
      modalSelecionado: [],
      formCadastro: { usuarios: [] },
      selected: [],
      itens: [],
      itensIniciais: [],
      usuariosSga: [],
      produtosSga: [],
      categoriasSga: [],
      cooperativasSga: [],
      regionaisSga:[],
      tiposSga: [],
      colunas: {},
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    teste() {},
    buscaCategoria(item) {
      item.alteraCategoria = true;
      this.$vs.loading();
      service
        .post("IntegracaoSGA", `BuscaDominioSGA`, {
          idIntegracao: this.$route.params.idIntegracao,
          chave: "Categoria",
          idTipoVeiculo: item.idSGA,
        })
        .then((res) => {
          
          item.categoriasSga = [];
          if (typeof res.data != "string")
            res.data.forEach((element) => {
              item.categoriasSga.push({
                id: element.codigo_categoria,
                label: element.descricao_categoria,
              });
            });
          this.$vs.loading.close();
        });
    },
    criaSubItem(item, sga) {
      item.idSGAAUX = sga;
    },
    criaItem(item, sga) {
      item.idSGA = sga;
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    updataItem(item, sga) {
      if (sga) item.idSGA = sga.id;
    },
    updataItem2(item) {
      item.idSGA = item.sga;
    },
    updataSubItem(item, sga) {
      if (sga) item.idSGAAUX = sga.id;
      
    },
    updataSubItem2(item) {
      item.idSGAAUX = item.sga;
    },
    onSubmit() {
      //this.$vs.loading();

      var action = "Atualizar";
      var msgRetorno = "Dados Atualizados com sucesso";
      var listSend = [];
      var listInicial = this.itensIniciais;
      var listAlterado = this.itens;
      
      

      listAlterado.forEach((element) => {
        if (element.id_integracaoDePara) {
          var aux = listInicial.find(
            (x) => x.id_integracaoDePara == element.id_integracaoDePara
          );
          if (aux) {
            
            if (
              aux.idSGA != element.idSGA ||
              aux.idSGAAUX != element.idSGAAUX
            ) {
              
              listSend.push(element);
            }
          }
        } else {
          var aux;
          if (element.tipo.indexOf("Cota -") > 0) {
            aux = listInicial.find(
              (x) =>
                x.idTx2 == element.idTx2 &&
                x.idSGAAUX == element.idSGAAUX &&
                x.tipo == element.tipo
            );
          } else {
            aux = listInicial.find(
              (x) => x.idTx2 == element.idTx2 && x.tipo == element.tipo
            );
          }
          if (aux) {
            //
            if (
              aux.idSGA != element.idSGA ||
              aux.idSGAAUX != element.idSGAAUX
            ) {
              
              listSend.push(element);
            }
          }
        }
      });

      var form = {
        idIntegracao: this.$route.params.idIntegracao,
        list: listSend,
      };

      if (listSend.length > 0) {
        this.aguardeCadastro = true;
        service
          .post("IntegracaoSGA", "salvarDePara", form)
          .then((res) => {
            this.aguardeCadastro = false;
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: `Operação Realizada com sucesso`,
              color: "success",
            });
            this.$vs.loading.close();
            this.buscaDadosTx2();
            this.$emit("concluido");
          })
          .catch((error) => {
            this.aguardeCadastro = false;
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: error,
              color: "danger",
            });
          });
      } else {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Nenhuma Alteração foi efetuada",
          color: "danger",
        });
        this.$vs.loading.close();
      }
    },
    buscaDadosTx2() {
      return new Promise(async (resolve, reject) => {
        this.selected = [];
        this.$vs.loading();

        service
          .post("IntegracaoSGA", `BuscaListaIntegracaoTx2`, {
            idIntegracao: this.$route.params.idIntegracao,
          })
          .then((res) => {
            
            this.itens = [];
            this.itensIniciais = [];
            res.data.forEach((element) => {
              element.categoriasSga = [];
              element.alteraCategoria = false;
              this.itens.push(element);
            });
            this.itensIniciais = JSON.parse(JSON.stringify(this.itens));
            
            this.$vs.loading.close();
            resolve();
          })
          .catch((e) => {
            
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Nenhum Registro Encontrado",
              color: "danger",
            });
            this.$vs.loading.close();
            reject();
          });
      });
    },
    buscaUsuariosSga() {
      service
        .post("IntegracaoSGA", `BuscaDominioSGA`, {
          idIntegracao: this.$route.params.idIntegracao,
          chave: "Voluntarios",
        })
        .then((res) => {
          res.data.forEach((element) => {
            this.usuariosSga.push({
              id: element.codigo_voluntario,
              label: element.nome,
            });
          });
        });
    },
    buscaCooperativasSga() {
      service
        .post("IntegracaoSGA", `BuscaDominioSGA`, {
          idIntegracao: this.$route.params.idIntegracao,
          chave: "Regional",
        })
        .then((res) => {
          res.data.forEach((element) => {
            this.cooperativasSga.push({
              id: element.codigo_regional,
              label: element.nome,
            });
          });
        });
    },
    buscaRegionaisSga() {
      service
        .post("IntegracaoSGA", `BuscaDominioSGA`, {
          idIntegracao: this.$route.params.idIntegracao,
          chave: "Divisão",
        })
        .then((res) => {
          res.data.forEach((element) => {
            this.regionaisSga.push({
              id: element.codigo_regional,
              label: element.nome,
            });
          });
        });
    },
    buscaProdutosSga() {
      service
        .post("IntegracaoSGA", `BuscaDominioSGA`, {
          idIntegracao: this.$route.params.idIntegracao,
          chave: "Produtos",
        })
        .then((res) => {
          res.data.forEach((element) => {
            this.produtosSga.push({
              id: element.codigo_produto,
              label: element.codigo_produto + " - " + element.decricao_produto,
            });
          });
        });
    },
    buscaTiposSga() {
      service
        .post("IntegracaoSGA", `BuscaDominioSGA`, {
          idIntegracao: this.$route.params.idIntegracao,
          chave: "TipoVeiculo",
        })
        .then((res) => {
          
          res.data.forEach((element) => {
            this.tiposSga.push({
              id: element.codigo_tipo,
              label: element.descricao_tipo,
            });
          });
        });
    },

    async preencheListaTx2() {
      this.itens = [];
      this.buscaUsuariosSga();
      this.buscaCooperativasSga();
      this.buscaRegionaisSga();
      this.buscaProdutosSga();
      this.buscaTiposSga();
      await this.buscaDadosTx2();
    },
    openSideBar(dados) {
      dados.idIntegracao == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
    },
    opemModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;
      var item = this.itens.find((x) => x.idIntegracao == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != "createdAt" &&
          element != "updatedAt" &&
          element != "deletedAt" &&
          element.indexOf("id") != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    concluido() {
      this.preencheListaTx2();
    },
    getStatusColor(data) {
      if (data == null) return "success";
      return "danger";
    },
    getStatusString(data) {
      if (data == null) return "Ativo";
      return "Inativo";
    },
  },
  created() {
    this.preencheListaTx2();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
<!------------ END SCRIPT ------------>


<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}
.simpleTablePrincipal {
  tr:nth-child(odd) {
    background-color: #fff;
    td {
      padding: 3px 5px;
    }
  }
  tr:nth-child(even) {
    background-color: #e7e7e7;
    td {
      padding: 3px 5px;

      .v-select {
        background-color: #fff;
      }
    }
  }
}
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<!------------ END STYLE ------------>
